import { render, staticRenderFns } from "./approve-list-record.vue?vue&type=template&id=605efcbc"
import script from "./approve-list-record.vue?vue&type=script&lang=js"
export * from "./approve-list-record.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports